import I18n from '@/shared/components/i18n'

export default (key, options) => I18n.t(key, options.hash)
